<!-- ═══════════════ THE WEB3 LAUNCHPAD SECTION (NEW) ═══════════════ -->
<section class="max-w-[1320px] mx-auto px-6 lg:px-10 pt-6 pb-12 relative z-10 animate-slide-up">

  <!-- Title Area -->
  <div class="mb-10 text-center max-w-xl mx-auto">
    <span
      class="text-gold text-xs uppercase tracking-widest font-extrabold bg-gold/10 px-3.5 py-1.5 rounded-full border border-gold/25">DEX
      Launchpad</span>
    <h2
      class="font-display font-black text-[38px] md:text-[44px] uppercase tracking-wider text-white mt-4 leading-tight">
      Decentralized Web3 Launches</h2>
    <p class="text-text-muted text-[14.5px] mt-3">Invest early in high-potential verified Web3, NFT, and DeFi
      cross-chain protocol pools.</p>
  </div>

  <!-- Active and Upcoming Grid -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6.5">
    @for (project of state.launchpadProjects(); track project.symbol) {
    <div
      class="card p-6 flex flex-col justify-between relative overflow-hidden transition-all duration-300 hover:scale-[1.02] border-white/[0.08]"
      [class.!border-gold/30]="project.status === 'live'">

      <!-- Status indicator tag -->
      <div class="flex justify-between items-start mb-6">
        <div class="token-badge w-12 h-12 text-sm" [style.background]="project.color">{{ project.symbol.charAt(0) }}
        </div>
        <div>
          @if (project.status === 'live') {
          <span
            class="text-[10px] font-extrabold text-emerald-400 bg-emerald-950/40 px-3 py-1.5 rounded-full border border-emerald-500/25 uppercase tracking-widest animate-pulse">●
            Active Sale</span>
          } @else {
          <span
            class="text-[10px] font-extrabold text-yellow-400 bg-yellow-950/40 px-3 py-1.5 rounded-full border border-yellow-500/25 uppercase tracking-widest">Upcoming</span>
          }
        </div>
      </div>

      <div>
        <h3 class="font-display font-black text-xl text-white tracking-wide leading-tight mb-1.5">{{ project.name }}
          ({{ project.symbol }})</h3>
        <p class="text-text-muted text-[12.5px] leading-relaxed mb-6 font-medium">{{ project.desc }}</p>

        <div
          class="bg-black/35 rounded-2xl p-4 border border-white/[0.03] flex flex-col gap-3.5 mb-6 text-xs text-text-muted">
          <div class="flex justify-between">
            <span>Token Price Ratio</span>
            <span class="font-bold text-white">{{ project.ratio }}</span>
          </div>
          <div class="flex justify-between">
            <span>Funding Target</span>
            <span class="font-bold text-white">{{ project.target }} BNB</span>
          </div>
          <div class="flex justify-between">
            <span>Funds Raised</span>
            <span class="font-bold text-gold">{{ project.raised }} / {{ project.target }} BNB</span>
          </div>
          <div class="flex justify-between border-t border-white/[0.03] pt-3">
            <span>Sale Deadline</span>
            <span class="font-extrabold text-white">{{ project.endsIn }}</span>
          </div>
        </div>
      </div>

      <div>
        <!-- Progress bar -->
        <div class="mb-5">
          <div class="flex justify-between text-[11px] font-bold text-text-dim uppercase tracking-wider mb-2">
            <span>Pool Filled</span>
            <span>{{ project.progress }}%</span>
          </div>
          <div class="custom-progress">
            <div class="custom-progress-bar" [style.width.%]="project.progress"></div>
          </div>
        </div>

        @if (project.status === 'live') {
        <button (click)="state.openLaunchpadModal(project)"
          class="btn-gold w-full py-3.5 rounded-xl text-[12px] font-bold tracking-widest uppercase shadow-md">
          Participate Pool
        </button>
        } @else {
        <button (click)="state.triggerNotification('Whitelist registration starts in 3 days!')"
          class="btn-outline w-full py-3.5 rounded-xl text-[12px] font-bold tracking-widest uppercase cursor-pointer">
          Whitelist Open
        </button>
        }
      </div>
    </div>
    }
  </div>
</section>
